import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Monogram az avatarhoz: „Havasi Ferenc" → „H". */
export function monogram(name: string): string {
  const t = name.trim();
  return t ? t[0].toUpperCase() : "?";
}

/** Keresztnév a megszólításhoz: a megjelenített név utolsó szava, ha több szóból áll
 *  (magyar névsorrend: „Kovács Anna" → „Anna"), különben maga a név. */
export function firstName(displayName: string): string {
  const parts = displayName.trim().split(/\s+/);
  return parts.length > 1 ? parts[parts.length - 1] : parts[0] ?? "";
}
